export { default } from '@shikijs/langs/viml'
